export const classNames = names => (
  names.join(' ')
);

export const boolClass = (boolVal, classname) => (
  boolVal ? classname : null
);
